import moment from 'moment'
import InfiniteScroll from 'react-infinite-scroller'
import _ from 'lodash'
import styles from './List.css'

import {
  NAMESPACE_ITEMS
} from 'actions/inventory/constants'

class List extends React.Component {
  render () {
    const {transfers, transferDetail, searchForm} = this.props

    return ((transfers.length > 0) && <div className={styles['wrapper']}>
      <table className={styles['table-header']}>
        <thead>
          <tr>
            <th>Date</th>
            <th>From Outlet</th>
            <th>To Outlet</th>
            <th>Note</th>
            <th className='text-center'>{searchForm && searchForm.namespace === NAMESPACE_ITEMS ? 'Items' : 'Ingredient'}</th>
            <th className='text-center'>Quantity</th>
          </tr>
        </thead>
      </table>
      <div className={`${styles['table-content-wrapper']} transfer-table-content-wrapper`}>
        <InfiniteScroll
          pageStart={1}
          loadMore={this._onReachBottom}
          hasMore={this._hasMore()}
          useWindow={false}
          threshold={10}
          initialLoad={false}>
          <table className={`${styles['table-content']}`}>
            <tbody>
              {transfers.map(transfer => {
                const className = `${(transferDetail && transferDetail.id === transfer.id) ? styles.selected : ''}`
                if (transfer.isdaterow) {
                  return (<tr>
                    <td colSpan={6} className={styles.parentRow}>{moment(transfer.created_at).format('ddd MMM DD YYYY')}</td>
                  </tr>)
                } else {
                  return (<tr onClick={() => { this._onClickRow(transfer) }} className={className}>
                    <td>{moment(transfer.created_at).format('HH:mm')}</td>
                    <td>{transfer.from_outlet.name}</td>
                    <td>{transfer.to_outlet.name}</td>
                    <td>{this._note(transfer)}</td>
                    <td className='text-center'>{searchForm && searchForm.namespace === NAMESPACE_ITEMS ? this._itemName(transfer) : this._ingredientName(transfer)}</td>
                    <td className='text-center'>{searchForm && searchForm.namespace === NAMESPACE_ITEMS ? this._quantity(transfer) : this._ingredientQuantity(transfer)}</td>
                  </tr>)
                }
              })}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
      </div>)
  }

  _onClickRow = (transfer) => {
    const {listOnClickRow} = this.props
    listOnClickRow(transfer)
  }

  _hasMore = () => {
    const {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }

  _onReachBottom = () => {
    const {listOnReachBottom} = this.props
    listOnReachBottom()
  }

  _itemName = (transfer) => {
    if (transfer.history_details.length === 1) {
      if (!transfer.history_details[0].item_variant_name) {
        return transfer.history_details[0].item_name
      } else {
        return transfer.history_details[0].item_name + ' (' + transfer.history_details.length + ' variants) '
      }
    }

    if (transfer.history_details.length > 1) {
      let itemIds = []

      transfer.history_details.forEach((hd, index) => {
        if (!itemIds.includes(hd.item_id)) {
          itemIds.push(hd.item_id)
        }
      })

      if (itemIds.length === 1) {
        var itemName = transfer.history_details[0].item_name
        return itemName + ' (' + transfer.history_details.length + ' variants) '
      }

      if (itemIds.length > 1) {
        return itemIds.length + ' items'
      }
    }
  }

  _quantity = (transfer) => {
    let total = 0

    transfer.history_details.forEach((hd, index) => {
      total += hd.quantity
    })

    return transfer.is_sender ? -total : total
  }

  _note = (transfer) => {
    if (transfer.note) {
      return transfer.note
    } else {
      return '-'
    }
  }

  _ingredientName = ({history_details}) => {
    if (history_details.length < 0) {
      return ''
    }
    return history_details.length > 1 ? history_details.length + ' Ingredients' : history_details[0].ingredient_name
  }

  _ingredientQuantity = (transfer) => {
    const historyDetails = transfer.history_details
    if (historyDetails.length < 0) return ''

    return _.uniqBy(historyDetails, 'unit_id').length === 1 ? this._calculateIngredientQuantity(transfer.is_sender, historyDetails) : 'Multiple Transfered'
  }

  _calculateIngredientQuantity = (isSender, historyDetails) => {
    let totalQuantity = _.reduce(historyDetails, function (s, historyDetail) {
      return s + historyDetail.quantity
    }, 0)

    let stringTotal = totalQuantity + ' ' + historyDetails[0].unit_name
    if (isSender) return '-' + stringTotal

    return stringTotal
  }
}

export default List



// WEBPACK FOOTER //
// ./app/pages/Inventory/Transfer/List/List.js